module.exports = __webpack_public_path__ + "img/picto-tab-emotionnel.fed43728.svg";